import React from 'react';
import {
    Create,

    Toolbar,
    SaveButton,
} from 'react-admin';

import FilePull from './FilePull'

const styles = {
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em', marginBottom: '2em' },
};

const ShowFile=({props})=>{
    return(
      <FilePull  props={props} />
    )
}
const FileCreate = ({...props }) => (
    <Create  title='File downloads'   {...props}>
     
      <div style={styles.flexColumn}>
        <ShowFile  props={props} />
      </div>   
    </Create>
)

export default FileCreate;
